import PropTypes from 'prop-types';

export function ProgressBar({ label, value, max = 100 }) {
  return (
    <div className="relative w-full">
      <label
        id="score-label"
        htmlFor="score"
        className="absolute top-0 left-0 mb-0 block w-1/4 text-center text-xs text-white"
      >
        <span className="sr-only">{label}</span>
      </label>
      <progress
        aria-labelledby="score-label"
        id="score"
        max={max}
        value={value}
        className="block h-3 w-full overflow-hidden rounded-xl bg-slate-200 @lg:h-5 [&::-webkit-progress-bar]:bg-slate-200 [&::-webkit-progress-value]:bg-gradient-to-r [&::-webkit-progress-value]:from-emerald-500 [&::-webkit-progress-value]:via-cyan-500  [&::-webkit-progress-value]:to-purple-500 [&::-moz-progress-bar]:bg-gradient-to-r [&::-moz-progress-bar]:from-emerald-500 [&::-moz-progress-bar]:via-cyan-500 [&::-moz-progress-bar]:to-purple-500"
      >
        {value}
      </progress>
    </div>
  );
}

ProgressBar.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
};
